import { useUnit } from 'effector-react'

import { Dialog } from '@/components/ui/dialog'
import { Progress } from '@/components/ui/progress'
import type { DialogProps } from '@/dialogs/types'
import { $summaryProgress } from '@/models/chattingUI/chatSummary.ts'

export const ChatSummarizeProgressDialog = ({
  isOpen,
  onClose,
}: DialogProps) => {
  const progress = useUnit($summaryProgress)

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Chat summary progress</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description>
        <div className="text-title mb-4 mt-6 flex justify-between text-center text-sm">
          <span>{progress}%</span>
        </div>

        <Progress value={progress} />
      </Dialog.Description>
      <Dialog.ClosableFooter
        onClose={onClose}
        className="block"
        buttonClassName="w-full"
        closeText="Run in background"
      />
    </Dialog>
  )
}
